import type { NodeListResponse, NodeDetail, UpdateNodeRequest } from '@/types'

const MOCK_NODES_DATA: NodeDetail[] = [
  {
    id: 'aaaaaaaa-0001-0001-0001-000000000001',
    node_key: 'site-a-cam-01',
    name: 'Cam-01',
    company: '삼표 인천',
    site: 'site-a',
    status: 'online',
    agent_version: '0.1.0',
    hostname: 'rpi-a01',
    os: 'linux',
    last_seen_at: new Date(Date.now() - 12000).toISOString(),
    created_at: '2026-05-01T00:00:00Z',
    updated_at: new Date(Date.now() - 12000).toISOString(),
    capabilities: 'recording,upload,file_list,inference_recording.files,inference_recording.upload',
    inference_auto_upload: {
      status: 'on',
      supported: true,
      inference_enabled: true,
      enabled: true,
      time: '02:00',
      target: 'previous_day',
      clean_after_upload: true,
    },
    recording_auto_upload: {
      mode: 'inference',
      manual: { supported: true, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: false },
      inference: { supported: true, enabled: true, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: true },
    },
    video_status: {
      active_recording_kind: 'manual',
      manual: { recording: 'local_running', upload: 'idle', auto_upload: 'unsupported' },
      inference: { recording: 'unsupported', upload: 'idle', auto_upload: 'on' },
    },
    latest_metrics: {
      cpu_percent: 34.2,
      cpu_count: 8,
      memory_percent: 58.1,
      memory_total_bytes: 17179869184,
      disk_percent: 62.0,
      disk_total_bytes: 338228674560,
      disk_free_bytes: 128849018880,
      analysis_service_status: 'running',
      collected_at: new Date(Date.now() - 12000).toISOString(),
    },
  },
  {
    id: 'aaaaaaaa-0002-0002-0002-000000000002',
    node_key: 'site-a-cam-02',
    name: 'Cam-02',
    company: '삼표 인천',
    site: 'site-a',
    status: 'warning',
    agent_version: '0.1.0',
    hostname: 'rpi-a02',
    os: 'linux',
    last_seen_at: new Date(Date.now() - 90000).toISOString(),
    created_at: '2026-05-01T00:00:00Z',
    updated_at: new Date(Date.now() - 90000).toISOString(),
    capabilities: 'recording,upload,file_list',
    inference_auto_upload: {
      status: 'unsupported',
      supported: false,
      inference_enabled: false,
      enabled: false,
      time: '02:00',
      target: 'previous_day',
      clean_after_upload: true,
    },
    recording_auto_upload: {
      mode: 'off',
      manual: { supported: true, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: false },
      inference: { supported: false, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: true },
    },
    video_status: {
      active_recording_kind: null,
      manual: { recording: 'idle', upload: 'uploading', auto_upload: 'unsupported' },
      inference: { recording: 'unsupported', upload: 'idle', auto_upload: 'unsupported' },
    },
    latest_metrics: {
      cpu_percent: 88.5,
      cpu_count: 8,
      memory_percent: 91.2,
      memory_total_bytes: 17179869184,
      disk_percent: 78.0,
      disk_total_bytes: 97612893091,
      disk_free_bytes: 21474836480,
      analysis_service_status: 'running',
      collected_at: new Date(Date.now() - 90000).toISOString(),
    },
  },
  {
    id: 'aaaaaaaa-0003-0003-0003-000000000003',
    node_key: 'site-b-cam-01',
    name: 'Cam-01',
    company: '성신 단양',
    site: 'site-b',
    status: 'online',
    agent_version: '0.1.0',
    hostname: 'rpi-b01',
    os: 'linux',
    last_seen_at: new Date(Date.now() - 8000).toISOString(),
    created_at: '2026-05-02T00:00:00Z',
    updated_at: new Date(Date.now() - 8000).toISOString(),
    capabilities: 'recording,upload,file_list',
    inference_auto_upload: {
      status: 'unsupported',
      supported: false,
      inference_enabled: false,
      enabled: false,
      time: '02:00',
      target: 'previous_day',
      clean_after_upload: true,
    },
    recording_auto_upload: {
      mode: 'off',
      manual: { supported: true, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: false },
      inference: { supported: false, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: true },
    },
    video_status: {
      active_recording_kind: null,
      manual: { recording: 'idle', upload: 'idle', auto_upload: 'unsupported' },
      inference: { recording: 'unsupported', upload: 'idle', auto_upload: 'unsupported' },
    },
    latest_metrics: {
      cpu_percent: 12.0,
      cpu_count: 4,
      memory_percent: 42.3,
      memory_total_bytes: 8589934592,
      disk_percent: 55.0,
      disk_total_bytes: 477218588444,
      disk_free_bytes: 214748364800,
      analysis_service_status: 'running',
      collected_at: new Date(Date.now() - 8000).toISOString(),
    },
  },
  {
    id: 'aaaaaaaa-0004-0004-0004-000000000004',
    node_key: 'site-b-cam-02',
    name: 'Cam-02',
    company: '성신 단양',
    site: 'site-b',
    status: 'offline',
    agent_version: null,
    hostname: 'rpi-b02',
    os: 'linux',
    last_seen_at: new Date(Date.now() - 3600000).toISOString(),
    created_at: '2026-05-02T00:00:00Z',
    updated_at: new Date(Date.now() - 3600000).toISOString(),
    capabilities: null,
    inference_auto_upload: {
      status: 'unsupported',
      supported: false,
      inference_enabled: false,
      enabled: false,
      time: '02:00',
      target: 'previous_day',
      clean_after_upload: true,
    },
    recording_auto_upload: {
      mode: 'off',
      manual: { supported: false, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: false },
      inference: { supported: false, enabled: false, local_time: '02:00', timezone: 'Asia/Seoul', file_window: 'previous_day', delete_local_after_success: true },
    },
    video_status: {
      active_recording_kind: null,
      manual: { recording: 'idle', upload: 'idle', auto_upload: 'unsupported' },
      inference: { recording: 'unsupported', upload: 'idle', auto_upload: 'unsupported' },
    },
    latest_metrics: null,
  },
]

function stableText(value: string | null | undefined): string {
  return (value ?? '').toLocaleLowerCase()
}

function sortNodes(items: NodeDetail[]): NodeDetail[] {
  return [...items].sort((a, b) => {
    const companyA = a.company ?? 'Unassigned'
    const companyB = b.company ?? 'Unassigned'
    const companyDiff = stableText(companyA).localeCompare(stableText(companyB))
    if (companyDiff) return companyDiff
    const siteDiff = stableText(a.site).localeCompare(stableText(b.site))
    if (siteDiff) return siteDiff
    const displayDiff = stableText(a.name ?? a.node_key).localeCompare(stableText(b.name ?? b.node_key))
    if (displayDiff) return displayDiff
    const nodeKeyDiff = stableText(a.node_key).localeCompare(stableText(b.node_key))
    if (nodeKeyDiff) return nodeKeyDiff
    return a.id.localeCompare(b.id)
  })
}

export function mockNodes(params?: {
  company?: string
  site?: string
  status?: string
  limit?: number
  offset?: number
}): NodeListResponse {
  let items = MOCK_NODES_DATA
  if (params?.company) items = items.filter((n) => n.company === params.company)
  if (params?.site) items = items.filter((n) => n.site === params.site)
  if (params?.status) items = items.filter((n) => n.status === params.status)
  items = sortNodes(items)
  const total = items.length
  const offset = params?.offset ?? 0
  if (offset) items = items.slice(offset)
  if (params?.limit != null) items = items.slice(0, params.limit)
  return { items, total }
}

export function mockNodeDetail(nodeId: string): NodeDetail {
  const node = MOCK_NODES_DATA.find((n) => n.id === nodeId)
  if (!node) {
    return {
      id: nodeId,
      node_key: 'unknown',
      name: null,
      company: null,
      site: null,
      status: 'offline',
      agent_version: null,
      hostname: null,
      os: null,
      last_seen_at: null,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      latest_metrics: null,
      inference_auto_upload: null,
      recording_auto_upload: null,
      video_status: null,
      capabilities: null,
    }
  }
  return node
}

export function updateMockNode(nodeId: string, body: UpdateNodeRequest): NodeDetail {
  const node = mockNodeDetail(nodeId)
  if ('name' in body) node.name = body.name?.trim() || null
  if ('company' in body) node.company = body.company?.trim() || null
  if ('site' in body) node.site = body.site?.trim() || null
  node.updated_at = new Date().toISOString()
  return node
}
